import { render, staticRenderFns } from "./EnrolledCourses.vue?vue&type=template&id=2a1f4adc&scoped=true&"
import script from "./EnrolledCourses.vue?vue&type=script&lang=js&"
export * from "./EnrolledCourses.vue?vue&type=script&lang=js&"
import style0 from "./EnrolledCourses.vue?vue&type=style&index=0&id=2a1f4adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1f4adc",
  null
  
)

export default component.exports